var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#f5f5f5","height":"1000px"}},[_vm._v(" 接收参数 "),_c('p',[_vm._v("code:"+_vm._s(_vm.code))])])}
var staticRenderFns = []

export { render, staticRenderFns }